export const isIE = () => {
  if (typeof window !== 'undefined') {
    const ua = window.navigator && window.navigator.userAgent;
    return ua && (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1);
  }
};

export const isGoogleBot = userAgent => {
  if (
    !userAgent &&
    typeof window !== 'undefined' &&
    window &&
    window.navigator
  ) {
    userAgent = window.navigator.userAgent;
  }
  // Validate input
  if (typeof userAgent !== 'string' || userAgent.trim() === '') return false;

  const ua = decodeURIComponent(userAgent.trim()).toLowerCase();

  // Known Googlebot/crawler patterns (desktop, mobile, merchant, etc.)
  const googleBotPatterns = [
    /googlebot/i,
    /googlebot-mobile/i,
    /googlebot-image/i,
    /adsbot-google/i,
    /adsbot-google-mobile/i,
    /mediapartners-google/i,
    /apis-google/i,
    /feedfetcher-google/i,
    /google-structured-data-testing-tool/i,
    /google favicon/i,
    /google web preview/i,
    /googlemerchantcenter/i,
    /google shopping/i,
    /google-inspectiontool/i,
    /storebot-google/i,
  ];
  return googleBotPatterns.some(pattern => pattern.test(ua));
};

// The same test loadDataForRoutes and the SSR entry point both need: the crawler may
// arrive directly or via the prerender service, which forwards the original agent.
export const isGoogleBotRequest = req =>
  !!req &&
  (isGoogleBot(req.get('User-Agent')) ||
    isGoogleBot(req.get('X-User-Agent')) ||
    req.get('X-Prerender') === '1');
